import React from 'react';

import { useLocalization } from '../../../providers/LocaleProvider';
import { BodyRegularBR2 } from '../../Typography';

interface NotAvailableLabelProps {
  hasAlternatives: boolean;
}

const NotAvailableLabel = ({ hasAlternatives }: NotAvailableLabelProps) => {
  const { t } = useLocalization();

  return (
    <BodyRegularBR2>
      {hasAlternatives ? t('h24_variant_not_available_in_current_config') : t('not_available')}
    </BodyRegularBR2>
  );
};

export default NotAvailableLabel;
